













import { Component, namespace, Vue } from 'nuxt-property-decorator'
import { ISiteUnderReconstruction } from '~/assets/interfaces/site'
import ComponentLogo from '~/components/logo/logo.vue'

const siteStore = namespace('site')

@Component({
  components: {
    ComponentLogo,
  },
})
export default class ComponentSystemUnderReconstruction extends Vue {
  @siteStore.State('isUnderConstruction') readonly isUnderReconstruction!:
    | ISiteUnderReconstruction
    | boolean

  private head() {
    return {
      title: 'На сайте ведутся технические работы',
    }
  }
}
